<template>
    <v-container tag="section" id="news">
        <v-row>
            <v-col class="pt-sm-8 pt-6 pb-3 pb-sm-8">
                <h3 class="px-sm-9">{{ label }}</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col v-for="(item, index) in news" :key="item.id" sm="4" cols="12" :class="index > 2 ? 'pt-sm-8': 'py-sm-0'" class="d-flex">
                <v-card outlined tile flat :class="item.color ? `v-card__borders-${item.color}--left` : 'v-card__borders-local--left'" :href="item.link">
                    <!-- <v-img :src="item.image.imageURL" :alt="item.image.imageURL" v-if="item.image">
                        <v-card-title class="px-4 px-sm-3 pt-7 pb-1">
                            <h4 class="mb-0">{{ item.title }}</h4>
                        </v-card-title>
                    </v-img> -->
                    <v-card-title class="px-4 px-sm-7 pt-5 pb-0 pr-sm-11">
                        <h4 class="mb-0">
                            {{ item.title }}
                            <v-card-actions>
                                <v-btn absolute right top icon :title="`Opens in new tab. Show more information on ${item.title}`">
                                    <v-icon :color="item.color">mdi-open-in-new</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </h4>
                    </v-card-title>
                    <!-- <v-card-subtitle class="px-4 px-sm-7 mt-0 pt-3">
                        {{ item.subText }}
                    </v-card-subtitle> -->
                    <v-card-text class="px-4 px-sm-7 pt-4" v-html="item.content">
                    </v-card-text>
                    <v-card-subtitle class="px-4 px-sm-7 pb-5">{{ item.location }}</v-card-subtitle>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: [
            'label'
        ],
        data() {
            return {
                news: []
            }
        },
        mounted() {
            this.$axios.get(this.$store.state.client_vars.NEWS)
                .then(response => {
                    this.news = response.data
                })
                .catch(error => console.log('Failed to update from MOH', error))
        }
    }
</script>

<style lang="scss">
    #news {
        .v-card {
            display: flex;
            flex-direction: column;
            flex: 1 1 100%;

            .v-card__title {

                h4 {
                    // position: relative;
                    width: 100%;
                    display: flex;
                }
                
                * {
                    margin-bottom: 0;
                    padding: 0;
                }
            }

            .v-responsive__content {
                display: flex;
                align-items: flex-end;

                .v-card__title h4{
                    font-size: 1.25rem;
                    text-shadow: 0px 1px 6px #000;
                    color: white;
                    line-height: normal;
                }
            }

            .v-card__subtitle {
                font-size: 16px;
                font-weight: 500;
                line-height: 21px;
                margin-top: auto;
            }

            .v-card__text {
                color: var(--v-black-base);
                font-weight: 500;
                line-height: 23px;
                font-size: 16px;
            }
        }
    }
</style>
